<template>
  <header class="flex items-center gap-4 border-b border-border px-6 py-3 bg-background">
    <h2 class="text-lg font-semibold flex-1">{{ pageTitle }}</h2>
    <DropdownMenu>
      <DropdownMenuTrigger as-child>
        <Button variant="ghost" class="flex items-center gap-2">
          <Avatar class="h-7 w-7">
            <AvatarImage v-if="authStore.currentUser?.photoThumbnailUrl" :src="authStore.currentUser.photoThumbnailUrl" />
            <AvatarFallback class="text-xs">{{ initials }}</AvatarFallback>
          </Avatar>
          <span class="text-sm">{{ authStore.currentUser?.firstName }}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem @click="$router.push('/profile')">Profile</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem @click="handleLogout">Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

const initials = computed(() => {
  const user = authStore.currentUser
  if (!user) return '?'
  return (user.firstName?.[0] ?? '') + (user.lastName?.[0] ?? '')
})

const pageTitles = {
  dashboard: 'Dashboard',
  sessions: 'Sessions',
  'session-detail': 'Session Details',
  'session-vote': 'Vote on Topics',
  profile: 'My Profile',
  'my-debates': 'My Debates',
  'debate-detail': 'Debate Details',
  'admin-dashboard': 'Admin Dashboard',
  'admin-users': 'User Management',
  'admin-user-detail': 'User Details',
  'admin-topics': 'Topic Management',
  'admin-topic-create': 'Create Topic',
  'admin-topic-edit': 'Edit Topic',
  'admin-sessions': 'Session Management',
  'admin-session-create': 'Create Session',
  'admin-session-detail': 'Session Details',
  'admin-voting-results': 'Voting Results',
  'admin-pairing': 'Debate Pairing',
  'admin-pairing-history': 'Pairing History',
}

const pageTitle = computed(() => pageTitles[route.name] ?? 'Beit Midrash')

function handleLogout() {
  authStore.logout()
  router.push('/login')
}
</script>
